import Routes from './../../routes'

const SwitchLang = ({ route = 'dashboard', separator = '|' }) => (
  [
    <a key="1" href={Routes.findAndGetUrls(route, 'it').urls.as}>ITA</a>,
    <span key="2"> {separator} </span>,
    <a key="3" href={Routes.findAndGetUrls(route, 'en').urls.as}>EN</a >,
  ]
)

export default SwitchLang


// WEBPACK FOOTER //
// src/components/SwitchLang.js